import React from "react";
import { useParams } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { useSite } from "@/context/SiteContext";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: "This placeholder privacy statement will be replaced with the group's full policy. Black Diamond Ventures Group is committed to protecting the personal data of those who engage with us. Enquiry details submitted through this website are stored securely and used solely to respond to your enquiry and manage our relationship with you.",
  },
  cookies: {
    title: "Cookies",
    body: "This website uses only essential cookies required for secure sign-in to the group portal and core functionality. A full cookies policy will be published here.",
  },
  terms: {
    title: "Terms",
    body: "These placeholder terms govern the use of this website. Nothing on this website constitutes an offer, investment solicitation or a representation of financial performance.",
  },
  accessibility: {
    title: "Accessibility",
    body: "Black Diamond Ventures Group is committed to ensuring this website is accessible and usable for everyone, with strong contrast, readable typography and keyboard-friendly navigation. A full accessibility statement will be published here.",
  },
};

export default function Legal() {
  const { doc } = useParams();
  const { settings } = useSite();
  const c = CONTENT[doc] || CONTENT.privacy;

  return (
    <div data-testid="page-legal" className="bg-bd-ivory min-h-screen">
      <section className="pt-40 pb-16 bg-bd-black grain relative">
        <div className="relative z-10 max-w-3xl mx-auto px-6 md:px-12">
          <Reveal>
            <p className="overline text-bd-gold mb-6">Legal</p>
            <h1 className="font-serif text-4xl md:text-6xl text-bd-ivory leading-tight">{c.title}</h1>
          </Reveal>
        </div>
      </section>
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Reveal>
            <p className="text-base md:text-lg text-black/65 leading-relaxed">{c.body}</p>
            <p className="mt-10 text-sm text-black/40 border-t border-black/10 pt-6">
              {settings.company_name || "Black Diamond Ventures Group Ltd"} · Company No. {settings.company_no || "17369044"}
            </p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
